import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ApproveService } from './approve.service';
import { lastValueFrom } from 'rxjs';
import { ApproveModel } from './approve.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.scss']
})
export class ApproveComponent implements OnInit
{

  public tableData: Array<ApproveModel> = [];
  public isLoaded: boolean = true;
  public validationCode: string = '';
  public errorMessage: string = '';
  public isAprove: boolean = false;
  public selectedIds: string[] = [];
  public isBRL: boolean = false;
  public validatingTotp: boolean = false;

  constructor(public approveService: ApproveService,
              public authService : AuthService,
              private toastr: ToastrService,
              private modalService: NgbModal)
  {

  }
  ngOnInit(): void {
    this.getPendingWithdraw();
    this.isBRL = this.authService.getOriginCurrency() === 'BRL';
  }

  @ViewChild('requestTOTPCode') validateToken : ElementRef | any;

  async pasteTotpCode(): Promise<void> {
    try {
      this.validationCode = (await navigator.clipboard.readText()).trim();
    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  getPendingWithdraw()
  {
    this.isLoaded = false;

    this.approveService.getPendingWithdraw().subscribe((value)=>
    {
      this.tableData = value;
      this.isLoaded = true;
    });
  }
  

  approve(isAproved: boolean)
  {
    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.isLoaded = false;
    if(this.tableData.filter(t => t.selected).length === 0){
      this.toastr.error('Selecione um item para prosseguir com a operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    this.isAprove = isAproved;
    this.selectedIds = this.tableData.filter(t => t.selected).map(itm => itm.id);
    this.isLoaded = true;
    this.modalService.open(this.validateToken, {backdrop: "static", keyboard: false, centered: true, size: 'sm'});
  }

  async isValidTotp()
  {
    let isValid: boolean = false;
    await this.authService.validateTotpCode(this.validationCode).then(
      value => {
        isValid = value.isValid;
      }
    );
    return isValid;
  }

  async validateTotp()
  {
    if (this.validatingTotp) {           
      return;
    }

    this.validatingTotp = true;

    if(await this.isValidTotp())
    {

      if(this.selectedIds.length == 0)
      {
        this.modalService.dismissAll();
        this.toastr.error('Erro ao selecionar pagamentos!','Erro!',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      this.isLoaded = false;

      await lastValueFrom(this.approveService.approveOrNotWithdraw(this.selectedIds, this.isAprove, this.validationCode)).then(()=>{
        this.getPendingWithdraw();
        this.isLoaded = true;
        this.validatingTotp = false;
      });

      this.modalService.dismissAll();
      this.toastr.success('Operação realizada com sucesso!','Sucesso!',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.validatingTotp = false;
    }
    else
    {
      this.errorMessage = 'Código de autenticação inválido!';
      this.validatingTotp = false;
    }
  }
}
